// import from react
import { useState } from 'react';
import { Link } from 'react-router-dom';

// import data lists and styles
import { KOPER } from './data/koper';
import { GLAS } from './data/glas'

import './app.css';

// import components
import Tel from './Tel';

function Beslisboom() {
  // verwijs de state naar je array
  const [userChoice, setUserChoice] = useState(KOPER);
  // zet active class voor actieve button
  const [active, setActive] = useState('koper');

  const handleChoice = (topic, choice) => {
    setUserChoice(topic);
    setActive(choice)
  }

  function handleButton(itemId, choice) {
    // update de state
    setUserChoice(
      // loop over je state array en split in sub items
      userChoice.map((sub) => {
        // check of de itemID die je via de knop heb meegegeven overeenkomt met de item id in de sub loop
        // als er een match is dan hebben we de juiste array item gevonden
        if (sub.id === itemId) {
          // als er een match is destructoring we het object en updaten de key en value van de object item
          // in dit geval updaten we answerq: choice (choice is ook weer een waarde die komt van uit de button click)
          return { ...sub, answerq: choice };
        } else {
          // als er geen match is return item ongewijzigd
          return sub;
        }
      })
    );
  }

  

  return (
    <div>
      <div className='contentBox'>
        <div className='center'>
          <button className={active === 'koper' ? 'active btn-answer': 'btn-answer'} onClick={() => handleChoice(KOPER, 'koper')}>Koper</button>
          <button className={active === 'glas' ? 'active btn-answer': 'btn-answer'} onClick={() => handleChoice(GLAS, 'glas')}>Glas</button>
        </div>
        {/* loop over DATA array of objects en genereer voor elk item een question box */}
        {userChoice.map((item) => {
          return (
            <div className='questionBox' key={item.id}>
              <h2 className='question'>{item.vraag}</h2>
              {item.subHead ? <h3 className='question'>{item.subHead}</h3> : ''}
              <div>
                <div className='center'>
                  <button
                    onClick={() => handleButton(item.id, true)}
                    className={
                      item.answerq ? 'btn-answer active' : 'btn-answer'
                    }
                    id='btnYes'
                  >
                    Ja
                  </button>
                  <button
                    onClick={() => handleButton(item.id, false)}
                    className={
                      !item.answerq ? 'btn-answer active' : 'btn-answer'
                    }
                    id='btnNo'
                  >
                    Nee
                  </button>
                </div>
              </div>
              <div className='answerBox'>
                {/* genereer welk antwoord je naar gebruiker laat zien */}
                {item.answerq ? (
                  <p className='answerY'>{item.ja}</p>
                ) : (
                  <p className='answerN'>{item.nee}</p>
                )}

                {/* genereer handleiding button wanneer nee wordt geselecteerd */}
                {item.handleiding && !item.answerq ? (
                  <Link to={item.handleiding}>
                    <button className='btn-answer'>Handleiding</button>
                  </Link>
                ) : (
                  ''
                )}

                {/* genereer telefoon button wanneer deze aanwezig is */}
                {item.tel ? (
                  <button
                    phone='+318000226389'
                    className='btn-answer telButton'
                  >
                    <Tel phone='+318000226389'>
                      <i className='fa-solid fa-phone'></i>
                      Bel MI
                    </Tel>
                  </button>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Beslisboom;
